function getPhotoGroup(Number) {
  const Arr_Groups = [
    { Value: "a", Group: "Group1" },
    { Value: "b", Group: "Group1" },
    { Value: "c", Group: "Group1" },
    { Value: "d", Group: "Group1" },
    { Value: "e", Group: "Group1" },
    { Value: "f", Group: "Group2" },
    { Value: "g", Group: "Group2" },
    { Value: "h", Group: "Group2" },
    { Value: "i", Group: "Group2" },
    { Value: "j", Group: "Group2" },
    { Value: "k", Group: "Group3" },
    { Value: "l", Group: "Group3" },
    { Value: "m", Group: "Group3" },
    { Value: "n", Group: "Group3" },
    { Value: "o", Group: "Group3" },
    { Value: "p", Group: "Group4" },
    { Value: "q", Group: "Group4" },
    { Value: "r", Group: "Group4" },
    { Value: "s", Group: "Group4" },
    { Value: "t", Group: "Group4" },
    { Value: "u", Group: "Group5" },
    { Value: "v", Group: "Group5" },
    { Value: "w", Group: "Group5" },
    { Value: "x", Group: "Group5" },
    { Value: "y", Group: "Group5" },
    { Value: "z", Group: "Group5" },
    { Value: "0", Group: "Group6" },
    { Value: "1", Group: "Group6" },
    { Value: "2", Group: "Group6" },
    { Value: "3", Group: "Group6" },
    { Value: "4", Group: "Group6" },
    { Value: "5", Group: "Group7" },
    { Value: "6", Group: "Group7" },
    { Value: "7", Group: "Group7" },
    { Value: "8", Group: "Group7" },
    { Value: "9", Group: "Group7" },
    { Value: 0, Group: "Group6" },
    { Value: 1, Group: "Group6" },
    { Value: 2, Group: "Group6" },
    { Value: 3, Group: "Group6" },
    { Value: 4, Group: "Group6" },
    { Value: 5, Group: "Group7" },
    { Value: 6, Group: "Group7" },
    { Value: 7, Group: "Group7" },
    { Value: 8, Group: "Group7" },
    { Value: 9, Group: "Group7" },
  ];

  let Arr_Groups_Filtered = Arr_Groups.filter(
    (Object) => Object.Value === Number
  );

  if (Arr_Groups_Filtered.length === 0) {
    return "GroupS";
  } else {
    return Arr_Groups_Filtered[0].Group;
  }
}

module.exports = getPhotoGroup;
